import { GlButton, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { VALID_DESIGN_FILE_MIMETYPE } from './constants';
export default {
    name: 'DesignUploadButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        isSaving: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'upload'
    ],
    methods: {
        openFileUpload () {
            this.$refs.fileUpload.click();
        },
        onFileUploadChange (e) {
            this.$emit('upload', e.target.files);
        }
    },
    VALID_DESIGN_FILE_MIMETYPE
};
